module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-dde7e7465f452fc8eebd72eef7c64f62.png";